import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProposedLeadService } from '@features/leads/services/proposed-lead.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@capturum/ui/api';
import { PublicTranslationService } from '@core/services/public-translation.service';
import { ProposedLead } from '@features/leads/models/proposed-lead.model';

@Injectable({ providedIn: 'root' })
export class LgProposalResolver implements Resolve<any> {
  constructor(
    private api: ProposedLeadService,
    private publicTranslateService: PublicTranslationService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly toastService: ToastService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const token = route.paramMap.get('token')!;
    const status = route.paramMap.get('status')!;

    return this.api.getProposalStatus(token, status).pipe(
      switchMap((response: ProposedLead) => {
        const lang = response?.locale || 'en';
        const tenant = response?.tenant || null;

        return this.publicTranslateService.loadFilteredTranslationsForTenant([], lang, tenant).pipe(
          map(() => {
            this.translateService.use(lang);

            return {
              hasError: !response?.lead,
              response: response,
              status: status,
            };
          })
        );
      }),
      catchError((response) => {
        const lang = response?.locale || 'en';

        return this.publicTranslateService.loadFilteredTranslations([], lang).pipe(
          map(() => {
            return {
              hasError: true,
              response: response,
              status: status,
            };
          })
        );
      })
    );
  }
}
